import { render } from "./GaleriaLandingPage.vue?vue&type=template&id=39a27744&scoped=true"
import script from "./GaleriaLandingPage.vue?vue&type=script&lang=js"
export * from "./GaleriaLandingPage.vue?vue&type=script&lang=js"

import "./GaleriaLandingPage.vue?vue&type=style&index=0&id=39a27744&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39a27744"]])

export default __exports__